import React from 'react';
import './TorrentCards.css';
import TorrentCard from './TorrentCard/TorrentCard';
export default function TorrentCards({torrents, isDeletable, isShareable, isUserVisible}) {
    return <div className='TorrentCards'>{torrents.map((torrent) => <TorrentCard key={torrent._id} torrent={torrent} isShareable={isShareable} isDeletable={isDeletable} isUserVisible={isUserVisible} />)}</div>
}